<button (click)='openFeedbackDialog()' class='feedback-button'>
  <img alt='Parkbase feedback button' src='/assets/theme/Logo_ParkBase-world.png' /> | Feedback
</button>
